<template>
  <div>
    <marketing-list v-show="tabType === 1" @handleShow="handleShow" />
    <marketing-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import marketingList from './list.vue'
import marketingShow from './show.vue'
export default {
  components: { marketingList, marketingShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>